function empty(val) {
    // test results
    //---------------
    // []        true, empty array
    // {}        true, empty object
    // null      true
    // undefined true
    // ""        true, empty string
    // ''        true, empty string
    // 0         false, number
    // true      false, boolean
    // false     false, boolean
    // Date      false
    // function  false

    if (val === undefined) return true;

    if (typeof (val) === 'function' || typeof (val) === 'number' || typeof (val) === 'boolean' || Object.prototype.toString.call(val) === '[object Date]') return false;

    // null or 0 length array
    if (val == null || val.length === 0) return true;

    if (typeof (val) === 'object') {
        // empty object

        let r = true;
        for (const f in val) {
            if (Object.hasOwnProperty.call(val, f)) {
                r = false;
            }
        }
        return r;
    }

    return false;
}

function buscar_clave_donde_encuentre_substring(string, array_de_substrings) {
    for (let i = 0; i < array_de_substrings.length; i++) {
        if (string.includes(array_de_substrings[i])) {
            return i;
        }
    }

    return false;
}

function in_array(needle, haystack) {
    for (const i in haystack) {
        if (haystack[i] == needle) return true;
    }
    return false;
}

export {
    empty,
    buscar_clave_donde_encuentre_substring,
    in_array
};
